import { render } from "./Devices.vue?vue&type=template&id=628d1ccc"
import script from "./Devices.vue?vue&type=script&scoped=true&lang=js"
export * from "./Devices.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__